import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import EliteSurfaceRestoration from "./sections/EliteSurfaceRestoration";
import TheFlowMethod from "./sections/TheFlowMethod";
import OurDetailingMenu from "./sections/OurDetailingMenu";
import StartYourTransformation from "./sections/StartYourTransformation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <EliteSurfaceRestoration />
      <TheFlowMethod />
      <OurDetailingMenu />
      <StartYourTransformation />
      <Footer />
    </div>;
}